import * as yup from 'yup';
import { validate } from '../../../shared/utils/validation.utils';
import { fullNameSchema } from '../auth.validation';

const schema = yup.object().shape({
    name: fullNameSchema,
});

export const validateUpdateProfileForm = data => validate(schema, data, {
    convert: true,
    abortEarly: false,
});
